import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { NewRequestsFormComponent } from './new-requests-form.component';

@NgModule({
  declarations: [NewRequestsFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomDropdownModule,
    CustomDatePickerModule,
    MaterialModule,
    CustomTimpickerModule,
    CustomInputModule,
    MatPaginatorModule,
  ],
})
export class NewRequestsFormModule {}
